<div class="responsive-card d-flex flex-column gap-4">
  <div class="responsive-card-title" i18n>Account Details</div>
  <div class="inner-card-grid">
    <div class="inner-card">
      <div class="d-flex gap-4 justify-content-between align-items-center w-100">
        <span class="inner-card-label" i18n>New Assets Added</span>
        <div class="d-flex flex-column gap-2">
          <span class="inner-card-value" i18n>{{ desiredFundingAmount | currency }}</span>
          <div class="inner-card-subtext" *ngIf="useEntireBalance" i18n>Entire Balance Used*</div>
        </div>
      </div>
    </div>
    <div class="inner-card">
      <div class="d-flex gap-4 justify-content-between align-items-center w-100">
        <div class="d-flex gap-2 align-items-center" [style.max-width.rem]="9.25">
          <span class="inner-card-label" i18n>Est. Combined Variable Benefit Balance</span>
          <img
            [ngbTooltip]="combinedBalanceTooltip"
            [triggers]="'hover focus click'"
            [style.height.rem]="1.5"
            [style.width.rem]="1.5"
            [src]="'assets/icons/grey/CircleQuestion.svg'"
            alt="" />
        </div>
        <span class="inner-card-value" i18n>{{ combinedVbAccountBalance | currency }}</span>
      </div>
    </div>
    <div class="inner-card">
      <div class="d-flex gap-4 justify-content-between align-items-center w-100">
        <div class="d-flex gap-2 align-items-center" [style.max-width.rem]="9.25">
          <span class="inner-card-label" i18n>Estimated Annual Total</span>
          <img
            [ngbTooltip]="estimatedAnnualTotalTooltip"
            [triggers]="'hover focus click'"
            [style.height.rem]="1.5"
            [style.width.rem]="1.5"
            [src]="'assets/icons/grey/CircleQuestion.svg'"
            alt="" />
        </div>
        <span class="inner-card-value" i18n>{{ estimatedAnnualTotal | currency }}</span>
      </div>
    </div>
    <div class="inner-card">
      <div class="d-flex gap-4 justify-content-between align-items-center w-100">
        <div class="d-flex gap-2 align-items-center" [style.max-width.rem]="9.25">
          <span class="inner-card-label" i18n>Effective Date{{ effectiveDateAsterisks }}</span>
          <img
            [ngbTooltip]="effectiveDateTooltip"
            [triggers]="'hover focus click'"
            [style.height.rem]="1.5"
            [style.width.rem]="1.5"
            [src]="'assets/icons/grey/CircleQuestion.svg'"
            alt="" />
        </div>
        <span class="inner-card-value" i18n>{{ effectiveDate }}</span>
      </div>
    </div>
    <div class="inner-card">
      <div class="d-flex gap-4 justify-content-between align-items-center w-100">
        <div class="d-flex gap-2 align-items-center" [style.max-width.rem]="9.25">
          <span *ngIf="annualMinimumDetails?.isEstimated; else annualMinimumLabel" class="inner-card-label" i18n>
            Estimated Annual Minimum
          </span>
          <ng-template #annualMinimumLabel>
            <span class="inner-card-label" i18n>Annual Minimum</span>
          </ng-template>
          <img
            [ngbTooltip]="annualMinimumTooltip"
            [triggers]="'hover focus click'"
            [style.height.rem]="1.5"
            [style.width.rem]="1.5"
            [src]="'assets/icons/grey/CircleQuestion.svg'"
            alt="" />
        </div>
        <span class="inner-card-value" i18n>{{ annualMinimumDetails?.minimumAnnualWithdrawalAmount | currency }}</span>
      </div>
    </div>
    <div class="inner-card">
      <div class="d-flex gap-4 justify-content-between align-items-center w-100">
        <span class="inner-card-label" [style.max-width.rem]="9.25" i18n>CRA Minimum Calculation Age</span>
        <div class="d-flex flex-column gap-2">
          <span class="inner-card-value">{{ annualMinimumDetails?.formattedDateOfBirth }}</span>
          <div class="inner-card-subtext" i18n>
            {{ minimumAgePrefix }}: Age {{ annualMinimumDetails?.minimumAgeDateOfBirth | age }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex flex-column gap-3">
    <small class="helper-text" *ngIf="useEntireBalance" i18n>
      *Amount reflects full balance as of submission date. Final amount may vary based on effective date.
    </small>
    <small class="helper-text" i18n>
      {{ effectiveDateAsterisks }}Actual effective dates are subject to variation of up to five weeks from the set date.
    </small>
  </div>
</div>
